// Redux action types
///rc-call-start-notify
export const RINGCENTRAL_AGENTNAME_SET = 'one-state-ring-central/agent-name/set';
///rc-call-ring-notify
export const RINGCENTRAL_AGENTNAME_RESET = 'one-state-ring-central/agent-name/reset';
//rc-call-hold-notify